export default __webpack_public_path__ + "static/rochepossay-7981945ea22341484a9da5441f4959a1.webm";